"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useContainerFocusManger = function (_a) {
    var onEnter = _a.onEnter, onLeave = _a.onLeave;
    var containerRef = react_1.default.useRef(null);
    var _b = react_1.default.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var handleFocus = function () {
        if (isFocused)
            return;
        setIsFocused(true);
        onEnter && onEnter();
    };
    var handleKeyUp = function () {
        if (isFocused && containerRef.current && !containerRef.current.contains(document.activeElement)) {
            setIsFocused(false);
            onLeave && onLeave();
        }
    };
    react_1.default.useEffect(function () {
        var _a;
        window.addEventListener('keyup', handleKeyUp);
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('focus', handleFocus);
        return function () {
            var _a;
            window.removeEventListener('keyup', handleKeyUp);
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', handleFocus);
        };
    }, [isFocused]);
    return { containerRef: containerRef, tabIndex: isFocused ? -1 : 0 };
};
exports.default = useContainerFocusManger;
